<div class="TableSearchFilter">
  <div class="TableSearchFilter-input">
    <input [(ngModel)]="inputValue" type="text" [placeholder]="placeholder" />
    <!--        show X icon if input value is not empty-->
    <span
      *ngIf="inputValue"
      (click)="onClearInput()"
      class="TableSearchFilter-input-clear"
      >X</span
    >
  </div>
  <div class="TableSearchFilter-button d-inline-block">
    <button (click)="onSearch()">{{ buttonLabel }}</button>
  </div>
</div>
